// noinspection DuplicatedCode

import React, { useEffect, useState, useCallback, useMemo } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet } from "../../../fetchers";
import { useQuery } from "@tanstack/react-query";
import { Card } from "@material-tailwind/react";
import "react-toastify/dist/ReactToastify.css";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";
import { NewDownloadExcel } from "../../../components/tablecard/NewTableMechanise";
import Skeltons from "../../../components/loading/Skeltons";
import debounce from "lodash/debounce";

const PenerimaanBarangPage = () => {
  const initialState = {
    Bulan: new Date(),
    BisnisUnitID: "U0002",
    Bagian: "B",
  };

  const validations = [];
  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const [param, setParam] = useState({
    BisnisUnitID: "U0002",
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Bagian: "B",
  });

  const debouncedSetSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchQuery(value);
        setIsSearching(false);
      }, 800),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSetSearch.cancel();
    };
  }, [debouncedSetSearch]);

  const { data: monitoringData, isLoading, isFetching } = useQuery({
    queryKey: [
      "penerimaan-barang",
      param.BisnisUnitID,
      param.Bulan,
      param.Tahun,
      param.Bagian,
      searchQuery,
    ],
    queryFn: () => {
      const searchPath = searchQuery
        ? `/${encodeURIComponent(searchQuery)}`
        : "/";
      return fetchGet(
        `Procurement/Monitoring/PurchaseOrderPenerimaan/${param.BisnisUnitID}/${param.Bulan}/${param.Tahun}/${param.Bagian}${searchPath}`
      );
    },
    keepPreviousData: true,
    staleTime: 30000,
  });

  const handleSearchChange = useCallback(
    (input) => {
      const value =
        typeof input === "string" ? input : input?.target?.value || "";
      setSearchInput(value);
      debouncedSetSearch.cancel();
      if (value.trim() === "") {
        setSearchQuery("");
        setIsSearching(false);
      } else {
        setIsSearching(true);
        debouncedSetSearch(value);
      }
    },
    [debouncedSetSearch]
  );

  const filterApi = useCallback(() => {
    debouncedSetSearch.cancel();
    setSearchInput("");
    setSearchQuery("");
    setIsSearching(false);
    setParam({
      BisnisUnitID: values.BisnisUnitID,
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: new Date(values.Bulan).getFullYear().toString(),
      Bagian: values.Bagian || "B",
    });
  }, [values, debouncedSetSearch]);

  const header = useMemo(
    () => [
      { name: "No. PO", key: "PurchaseOrderID" },
      { name: "Tanggal PO", key: "TanggalPO", modifiers: "Date" },
      { name: "Keterangan", key: "Remarks", modifiers: "Text" },
      { name: "Bagian", key: "NamaBagian", modifiers: "Text" },
      { name: "Nama Supplier", key: "NamaSupplier", modifiers: "Text" },
      { name: "Nama Karyawan", key: "NamaKaryawan", modifiers: "Text" },
      { name: "Action", key: "Lihat", modifiers: "LihatPenerimaan" },
    ],
    []
  );

  const showLoading = isLoading && !monitoringData;

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4" />
        </div>
      </div>

      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className="w-1/4">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    name={"BisnisUnitID"}
                    title={"BisnisUnit"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className="w-1/4">
                  <HrdInputGenerator
                    type={"bulan"}
                    name={"Bulan"}
                    title={"Bulan"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className="w-1/4">
                  <HrdInputGenerator
                    type={"Bagian"}
                    name={"Bagian"}
                    title={"Bagian"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className="w-1/4">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Buka data
                  </label>
                  <button
                    type="button"
                    onClick={filterApi}
                    className="text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-7 py-2 text-center mr-2 mb-2"
                  >
                    Buka
                  </button>
                </div>
              </div>

              <div className="flex flex-col content-center">
                {showLoading ? (
                  <div className="w-full pt-0 items-left">
                    <Skeltons />
                  </div>
                ) : monitoringData ? (
                  <>
                    <NewDownloadExcel
                      data={monitoringData}
                      header={header}
                      menuController={handleSearchChange}
                      value={searchInput}
                      name={"No PO"}
                      title={"Penerimaan Barang"}
                      isFetching={isFetching}
                    />

                    {searchInput !== searchQuery && searchInput && (
                      <div className="px-4 text-xs text-blue-500">
                        Mengetik "{searchInput}"...
                      </div>
                    )}

                    {searchQuery && !isSearching && (
                      <div className="px-4 text-xs text-green-600">
                        Menampilkan hasil untuk "{searchQuery}"
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PenerimaanBarangPage;
